import axios from "axios";
import React, { useEffect, useState } from "react";
import Loader from "../../components/Loader/Loader";
// Positions Management component for Admin
const PositionsManagement = ({ userProfile }) => {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const handler = setTimeout(() => {
    fetchPositions();
    }, 300);
    return () => clearTimeout(handler);
  }, []);

  const fetchPositions = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/system/positions`);
      setPositions(response.data.positions || []);
    } catch (error) {
      console.error('Error fetching positions:', error);
    } finally {
      setLoading(false);
    }
  };

  const getPositionCategory = (position) => {
    const managementPositions = ['CEO', 'CTO', 'CFO', 'COO', 'VP', 'Director', 'General Manager', 'Regional Manager', 'Branch Manager', 'Department Head', 'Team Lead', 'Project Manager', 'Operations Manager', 'Assistant Manager'];
    const itPositions = ['Software Engineer', 'Senior Software Engineer', 'Lead Software Engineer', 'DevOps Engineer', 'System Administrator', 'Network Administrator', 'Database Administrator', 'IT Support Specialist', 'Business Analyst', 'Data Analyst', 'QA Engineer', 'UI/UX Designer', 'Product Manager', 'Technical Architect', 'IT Manager'];
    const financePositions = ['Accountant', 'Senior Accountant', 'Finance Manager', 'Financial Analyst', 'Budget Analyst', 'Tax Specialist', 'Auditor', 'Payroll Specialist', 'Treasury Analyst', 'Credit Analyst', 'Investment Analyst', 'Compliance Officer'];
    const hrPositions = ['HR Generalist', 'HR Specialist', 'HR Manager', 'Recruiter', 'Training Coordinator', 'Compensation Analyst', 'Employee Relations Specialist', 'Benefits Administrator', 'HR Business Partner', 'Talent Acquisition Specialist'];
    const operationsPositions = ['Operations Coordinator', 'Supply Chain Analyst', 'Logistics Coordinator', 'Warehouse Supervisor', 'Production Supervisor', 'Quality Control Inspector', 'Procurement Specialist', 'Inventory Manager', 'Facilities Manager', 'Security Officer', 'Maintenance Technician'];

    if (managementPositions.some(p => position.includes(p))) return 'management';
    if (itPositions.some(p => position.includes(p))) return 'it';
    if (financePositions.some(p => position.includes(p))) return 'finance';
    if (hrPositions.some(p => position.includes(p))) return 'hr';
    if (operationsPositions.some(p => position.includes(p))) return 'operations';
    return 'other';
  };

  const getCategoryLabel = (category) => {
    const labels = {
      'management': 'Management',
      'it': 'Information Technology',
      'finance': 'Finance',
      'hr': 'Human Resources',
      'operations': 'Operations',
      'other': 'Other'
    };
    return labels[category] || 'Other';
  };

  const filteredPositions = positions.filter(position =>
    position.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const positionStats = {
    total: positions.length,
    management: positions.filter(p => getPositionCategory(p) === 'management').length,
    it: positions.filter(p => getPositionCategory(p) === 'it').length,
    finance: positions.filter(p => getPositionCategory(p) === 'finance').length,
    hr: positions.filter(p => getPositionCategory(p) === 'hr').length,
    operations: positions.filter(p => getPositionCategory(p) === 'operations').length,
    other: positions.filter(p => getPositionCategory(p) === 'other').length
  };

  if (loading) {
    return <Loader />
  }

  return (
    <div className="positions-management w-full min-w-0">
      <div className="section-header">
        <h2>Positions Management</h2>
        <p className="section-subtitle">
          📋 {positions.length} predefined positions available across all departments
        </p>
      </div>

      <div className="positions-table-container">
        <div className="positions-search">
          <input
            type="text"
            placeholder="Search positions..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="w-full overflow-x-auto">
          <table className="positions-table">
            <thead>
              <tr>
                <th>#</th>
                <th className="whitespace-nowrap">Position Title</th>
                <th>Category</th>
                <th>Department</th>
              </tr>
            </thead>
            <tbody>
              {filteredPositions.map((position, index) => {
                const category = getPositionCategory(position);
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td className="whitespace-nowrap">
                      <strong>{position}</strong>
                    </td>
                    <td className="whitespace-nowrap">
                      <span className={`position-category ${category}`}>
                        {getCategoryLabel(category)}
                      </span>
                    </td>
                    <td className="whitespace-nowrap">{getCategoryLabel(category)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="positions-stats">
          <div>
            Showing {filteredPositions.length} of {positions.length} positions
          </div>
          <div>
            📊 Management: {positionStats.management} | IT: {positionStats.it} | Finance: {positionStats.finance} | HR: {positionStats.hr} | Operations: {positionStats.operations} | Other: {positionStats.other}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PositionsManagement;